// extracted by mini-css-extract-plugin
export default {"root":"ps506n","price":"Jieei3","saleOn":"Z9pDMO","preInstalled":"qMsUhA","description":"wOa0qe","taxHeightCompensation":"rCV0pr","bottom":"P2RpKp"};